// src/utils/regions.js
export const REGIONS = {
  DZ: "Algeria",
  AR: "Argentina",
  AU: "Australia",
  AT: "Austria",
  BE: "Belgium",
  BR: "Brazil",
  CN: "China",
  DK: "Denmark",
  FI: "Finland",
  GL: "Greenland",
  GT: "Guatemala",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  KZ: "Kazakhstan",
  LB: "Lebanon",
  LU: "Luxembourg",
  MX: "Mexico",
  MD: "Moldova",
  MC: "Monaco",
  MA: "Morocco",
  NL: "Netherlands",
  NZ: "New Zealand",
  NO: "Norway",
  PE: "Peru",
  PT: "Portugal",
  PR: "Puerto Rico",
  RO: "Romania",
  RU: "Russia",
  SA: "Saudi Arabia",
  SCOTLAND: "Scotland",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  ZA: "South Africa",
  KR: "South Korea",
  ES: "Spain",
  SE: "Sweden",
  TH: "Thailand",
  TN: "Tunisia",
  TR: "Turkey",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  UK: "United Kingdom",
  US: "United States",
  CA: "Canada",
  DE: "Germany",
  FR: "France",
  PL: "Poland",
  GR: "Greece",
  CH: "Switzerland",
  JP: "Japan",
  EU: "Europe",
  GLOBAL: "Global",
};

// Get all region codes as an array
export const REGION_CODES = Object.keys(REGIONS);

// Helper to get readable name by code
export const getRegionName = (code) => REGIONS[code] || code;
